__turbopack_context__.v({
  "className": "_6bD3dW_className",
  "variable": "_6bD3dW_variable",
});
